import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _styled12 from "styled-components";
import _styled11 from "styled-components";
import _styled10 from "styled-components";
import _styled9 from "styled-components";
import _styled8 from "styled-components";
import _styled7 from "styled-components";
import _styled6 from "styled-components";
import _styled5 from "styled-components";
import _styled4 from "styled-components";
import _styled3 from "styled-components";
import _styled2 from "styled-components";
import _styled from "styled-components";
/* eslint-disable react/static-property-placement */

import * as React from 'react';
import classnames from 'classnames';
import ReactHTMLParser from 'react-html-parser';
import { Analytics, AnalyticsLocationConsumer, trackEvent } from 'latitude-analytics';
import { Button } from '@latitude/button';
import { Link } from '@latitude/link';
import { BUTTON_STYLE } from '@latitude/core/utils/constants';
import './_login-form.scss';

var CardTypeLinkDivider = function CardTypeLinkDivider() {
  return /*#__PURE__*/React.createElement("div", {
    className: "row mt-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "seperator-line col-5"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-2 text-center static-text"
  }, "or"), /*#__PURE__*/React.createElement("div", {
    className: "seperator-line col-5"
  }));
};

var LoginForm = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(LoginForm, _React$Component);

  function LoginForm(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.handleClick = function (ev) {
      if (!_this.props.isOpen) return;
      var clickTarget = ev.target;
      var wrapperNode = _this.wrapperRef && _this.wrapperRef.current;
      var openElement = _this.props.openElement;

      if (wrapperNode && clickTarget instanceof Node && !wrapperNode.contains(clickTarget) && (!openElement || !openElement.contains(clickTarget))) {
        _this.props.onRequestClose();
      }
    };

    _this.handleKeyDown = function (event) {
      if (!_this.props.isOpen) return;

      if (event.keyCode === 27) {
        _this.props.onRequestClose();
      }
    };

    _this.doShowLegacySelector = function (event) {
      event.preventDefault();

      _this.setState({
        isSelectorVisible: true
      });
    };

    _this.doLaunchLegacyOSC = function (event) {
      event.preventDefault();

      if (_this.state.selectedCard) {
        var oscLogin = _this.state.selectedCard.login;
        var oscIdent = _this.state.selectedCard.id;
        window.open(oscLogin.url, oscLogin.target);
        trackEvent(_this.props, {
          category: 'button',
          action: 'online-service-centre',
          label: oscIdent,
          location: location
        });
      }
    };

    _this.wrapperRef = /*#__PURE__*/React.createRef();
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_this)); // selected card is null by default

    _this.state = {
      selectedCard: null,
      isSelectorVisible: false
    };
    return _this;
  }

  var _proto = LoginForm.prototype;

  _proto.componentDidMount = function componentDidMount() {
    document.addEventListener('mousedown', this.handleClick, false);
    document.addEventListener('keydown', this.handleKeyDown, false);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown, false);
    document.removeEventListener('mousedown', this.handleClick, false);
  };

  _proto.getSelectedCardName = function getSelectedCardName(cardId) {
    var selectedCardType = this.props.cardTypes.find(function (cardType) {
      return cardType.id === cardId;
    });
    return selectedCardType ? selectedCardType.name : null;
  }
  /**
   * Handles selection and tracking of credit card type from drop-down box
   */
  ;

  _proto.handleCardSelectChange = function handleCardSelectChange(event, analytics, location) {
    var cardTypes = this.props.cardTypes;
    var selectedItemTextValue = event.target.options[event.target.selectedIndex].text;
    var matchingCardTypes = cardTypes.filter(function (card) {
      return card.id === event.currentTarget.value;
    });

    if (matchingCardTypes.length > 0) {
      this.setState({
        selectedCard: matchingCardTypes[0]
      });
    } else {
      this.setState({
        selectedCard: null
      });
    }

    trackEvent(analytics, {
      category: 'drop-down',
      action: 'in-page-navigation',
      label: selectedItemTextValue,
      location: location
    });
  }
  /*
   * Close the popup on click outside of the search form
   * unless the click was on Login Button
   */
  ;

  _proto.render = function render() {
    var _this2 = this;

    var analytics = this.props.analytics;
    var selectedCard = this.state.selectedCard;
    var isSelectorVisible = this.state.isSelectorVisible; // work out links targets

    var selectedCardLoginTarget = selectedCard && selectedCard.login && selectedCard.login.target || null;
    var selectedCardUploadTarget = selectedCard && selectedCard.upload && selectedCard.upload.target || null;
    var selectedCardRegisterTarget = selectedCard && selectedCard.register && selectedCard.register.target || null; // productId's

    var lpayProductId = 'BPAULFIST';
    var nzLoansProductId = 'PLNZLF-WEB';
    var auLoansProductId = 'PLAULF-WEB'; // fix for link overriding default productId

    var selectedProductId = selectedCard && selectedCard.trackProductId || null;
    return /*#__PURE__*/React.createElement(AnalyticsLocationConsumer, null, function (location) {
      return /*#__PURE__*/React.createElement("div", {
        ref: _this2.wrapperRef,
        className: classnames('login-form', _this2.props.className, _this2.props.isOpen ? 'login-form--is-open' : '')
      }, /*#__PURE__*/React.createElement("div", {
        className: "row existing-customer"
      }, /*#__PURE__*/React.createElement("section", {
        className: "col-12 existing-customer__section"
      }, /*#__PURE__*/React.createElement("div", {
        className: "login-form__panel"
      }, /*#__PURE__*/React.createElement("h5", {
        className: "text--bold"
      }, ReactHTMLParser(_this2.props.loginForm.creditCardsPaneTitle || 'Credit Cards')), /*#__PURE__*/React.createElement(_StyledDiv, null, /*#__PURE__*/React.createElement(_StyledLink, {
        "data-trackid": "nav--login",
        className: "trackcustomanalytics btn-secondary",
        button: BUTTON_STYLE.SECONDARY,
        href: _this2.props.loginForm.creditCardsLoginUrl || 'https://servicecentre.latitudefinancial.com.au/login?migration=true',
        target: selectedCardLoginTarget,
        trackEventData: {
          action: 'service-centre-link',
          location: location
        },
        trackProductId: selectedProductId
      }, _this2.props.loginForm.creditCardsLoginLinkText || 'Log in'), /*#__PURE__*/React.createElement(_StyledLink2, {
        "data-trackid": "nav--register",
        className: "trackcustomanalytics btn-tertiary",
        button: BUTTON_STYLE.TERTIARY,
        href: _this2.props.loginForm.creditCardsRegisterUrl || 'https://servicecentre.latitudefinancial.com.au/register',
        target: selectedCardRegisterTarget,
        trackEventData: {
          action: 'service-centre-link',
          location: location
        },
        trackProductId: selectedProductId
      }, _this2.props.loginForm.creditCardsRegisterLinkText || 'Register')), _this2.props.showCreditCardsUpload && /*#__PURE__*/React.createElement(_StyledDiv2, null, /*#__PURE__*/React.createElement(Link, {
        "data-trackid": "nav--upload",
        className: "trackcustomanalytics",
        href: _this2.props.loginForm.creditCardsUploadUrl || 'https://www.latitudefinancial.com.au/upload/',
        target: selectedCardUploadTarget,
        trackEventData: {
          location: location
        }
      }, _this2.props.loginForm.creditCardsUploadLinkText || 'Upload documents')), _this2.props.showLsc && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CardTypeLinkDivider, null), /*#__PURE__*/React.createElement(_StyledDiv3, null, /*#__PURE__*/React.createElement("span", {
        className: "static-text"
      }, /*#__PURE__*/React.createElement("a", {
        href: "#",
        onClick: _this2.doShowLegacySelector
      }, "Log in"), "\xA0 to Legacy Online Service Centre")), /*#__PURE__*/React.createElement(_StyledDiv4, null, /*#__PURE__*/React.createElement(_StyledSpan, null, "Closing Soon")), /*#__PURE__*/React.createElement("div", {
        style: {
          display: isSelectorVisible ? 'flex' : 'none',
          flexDirection: 'row',
          padding: '0 5pt'
        }
      }, /*#__PURE__*/React.createElement("select", {
        style: {
          width: '75%',
          marginRight: '5%',
          marginBottom: '0'
        },
        className: "styled-select"
        /* js-siteHeader__personalised-link__select */
        ,
        id: "form-card-login__card",
        onChange: function onChange(event) {
          return _this2.handleCardSelectChange(event, analytics, location);
        }
      }, /*#__PURE__*/React.createElement("option", {
        value: ""
      }, ReactHTMLParser(_this2.props.loginForm.creditCardsSelectDefaultText || 'Select a card')), _this2.props.cardTypes.map(function (card) {
        return /*#__PURE__*/React.createElement("option", {
          key: card.id,
          value: card.id
        }, card.name);
      })), /*#__PURE__*/React.createElement(Button, {
        className: "btn-secondary",
        style: {
          width: '20%'
        },
        variant: BUTTON_STYLE.SECONDARY,
        disabled: !selectedCard,
        onClick: _this2.doLaunchLegacyOSC
      }, "Go"))))), _this2.props.showLpayPane && /*#__PURE__*/React.createElement("section", {
        className: "col-12 existing-customer__section"
      }, /*#__PURE__*/React.createElement("div", {
        className: "login-form__panel"
      }, /*#__PURE__*/React.createElement("h5", {
        className: "text--bold"
      }, ReactHTMLParser(_this2.props.loginForm.lpayPaneTitle || 'LatitudePay')), /*#__PURE__*/React.createElement("p", {
        className: "static-text"
      }, ReactHTMLParser(_this2.props.loginForm.lpayPaneIntro || 'Spread the cost of your purchases, with no interest, ever. Enjoy it now.')), /*#__PURE__*/React.createElement(_StyledDiv5, null, /*#__PURE__*/React.createElement(_StyledLink3, {
        button: BUTTON_STYLE.TERTIARY,
        className: "btn-tertiary",
        href: _this2.props.loginForm.lpayLoginLinkUrl || '',
        trackEventData: {
          location: location
        },
        trackProductId: lpayProductId
      }, _this2.props.loginForm.lpayLoginLinkText || 'Log In'), /*#__PURE__*/React.createElement(_StyledLink4, {
        className: "btn-tertiary",
        button: BUTTON_STYLE.TERTIARY,
        href: _this2.props.loginForm.lpaySignupLinkUrl || '',
        trackEventData: {
          location: location
        },
        trackProductId: lpayProductId
      }, _this2.props.loginForm.lpaySignupLinkText || 'Sign up')))), _this2.props.showLoansPane && /*#__PURE__*/React.createElement("section", {
        className: "col-12 existing-customer__section"
      }, /*#__PURE__*/React.createElement("div", {
        className: "login-form__panel"
      }, /*#__PURE__*/React.createElement("h5", {
        className: "text--bold"
      }, ReactHTMLParser(_this2.props.loginForm.loansPaneTitle || 'Personal Loans')), /*#__PURE__*/React.createElement("p", {
        className: "static-text"
      }, ReactHTMLParser(_this2.props.loginForm.loansPaneIntro || 'Login to manage your personal loan.')), /*#__PURE__*/React.createElement(_StyledLink5, {
        button: BUTTON_STYLE.TERTIARY,
        className: "btn-tertiary",
        href: _this2.props.loginForm.loansLoginLinkUrl || '',
        trackEventData: {
          location: location
        },
        trackProductId: _this2.props.isNZ ? nzLoansProductId : auLoansProductId
      }, _this2.props.loginForm.loansLoginLinkText || 'Log In'))), _this2.props.showPartnerPane && /*#__PURE__*/React.createElement("section", {
        className: "col-12 existing-customer__section"
      }, /*#__PURE__*/React.createElement("div", {
        className: "login-form__panel"
      }, /*#__PURE__*/React.createElement("h5", {
        className: "text--bold"
      }, ReactHTMLParser(_this2.props.loginForm.partnerPaneTitle || 'Partner Hub')), /*#__PURE__*/React.createElement("p", {
        className: "static-text"
      }, ReactHTMLParser(_this2.props.loginForm.partnerPaneIntro || 'Login to manage customer purchases.')), /*#__PURE__*/React.createElement(_StyledLink6, {
        className: "btn-tertiary",
        button: BUTTON_STYLE.TERTIARY,
        href: _this2.props.loginForm.partnerLoginLinkUrl || '',
        trackEventData: {
          location: location
        },
        trackProductId: "partner-hub"
      }, _this2.props.loginForm.partnerLoginLinkText || 'Log In')))));
    });
  };

  return LoginForm;
}(React.Component);

LoginForm.defaultProps = {
  isStickyOpen: false // eslint-disable-line react/default-props-match-prop-types

};
export default LoginForm;

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "LoginForm___StyledDiv",
  componentId: "sc-zl8lx4-0"
})(["display:flex;flex-direction:horizontal;"]);

var _StyledLink = /*#__PURE__*/_styled(Link).withConfig({
  displayName: "LoginForm___StyledLink",
  componentId: "sc-zl8lx4-1"
})(["align-self:flex-start;width:45%;margin-right:5%;color:#ffffff;"]);

var _StyledLink2 = /*#__PURE__*/_styled(Link).withConfig({
  displayName: "LoginForm___StyledLink2",
  componentId: "sc-zl8lx4-2"
})(["align-self:flex-end;width:45%;"]);

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "LoginForm___StyledDiv2",
  componentId: "sc-zl8lx4-3"
})(["text-align:center;"]);

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "LoginForm___StyledDiv3",
  componentId: "sc-zl8lx4-4"
})(["text-align:center;"]);

var _StyledDiv4 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "LoginForm___StyledDiv4",
  componentId: "sc-zl8lx4-5"
})(["text-align:center;padding:5pt 0;"]);

var _StyledSpan = /*#__PURE__*/_styled("span").withConfig({
  displayName: "LoginForm___StyledSpan",
  componentId: "sc-zl8lx4-6"
})(["background:#d6d3fa;border-radius:20px;color:#414141;font-size:14px;padding:5pt 10pt;"]);

var _StyledDiv5 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "LoginForm___StyledDiv5",
  componentId: "sc-zl8lx4-7"
})(["display:flex;flex-direction:horizontal;"]);

var _StyledLink3 = /*#__PURE__*/_styled(Link).withConfig({
  displayName: "LoginForm___StyledLink3",
  componentId: "sc-zl8lx4-8"
})(["align-self:flex-start;width:45%;margin-right:5%;"]);

var _StyledLink4 = /*#__PURE__*/_styled(Link).withConfig({
  displayName: "LoginForm___StyledLink4",
  componentId: "sc-zl8lx4-9"
})(["align-self:flex-end;width:45%;"]);

var _StyledLink5 = /*#__PURE__*/_styled(Link).withConfig({
  displayName: "LoginForm___StyledLink5",
  componentId: "sc-zl8lx4-10"
})(["width:45%;"]);

var _StyledLink6 = /*#__PURE__*/_styled(Link).withConfig({
  displayName: "LoginForm___StyledLink6",
  componentId: "sc-zl8lx4-11"
})(["width:45%;"]);